import { Sparkles } from 'lucide-react';
import { DiscordIcon } from '../icons/SocialIcons';
import { DISCORD_URL } from '../../constants/social';

export default function Community() {
  return (
    <section className="relative bg-gradient-to-b from-[#0d0a1a] to-[#0a0815] py-24 px-6 overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full bg-rose-400/10 blur-[100px] pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-rose-300/20 bg-rose-300/5 mb-6">
          <Sparkles className="w-4 h-4 text-rose-300" />
          <span className="text-rose-200 text-sm font-medium tracking-wider uppercase">Comunidad</span>
        </div>

        <h2 className="text-4xl sm:text-5xl font-bold text-white/90 mb-6 leading-tight">
          Los{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-300 via-pink-200 to-sky-300">
            Eugenialitos
          </span>
        </h2>

        <p className="text-slate-300/70 text-lg leading-relaxed max-w-2xl mx-auto">
          Una comunidad que se reúne cada noche para relajar el día, compartir un buen momento
          y disfrutar juntos de la calma. Todos son bienvenidos — no hay reglas más que el respeto
          y la buena energía.
        </p>

        <a
          href={DISCORD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 mt-8 px-6 py-3 rounded-2xl bg-[#5865f2]/80 hover:bg-[#5865f2] text-white font-medium text-sm shadow-lg shadow-black/20 transition-all duration-300 hover:-translate-y-0.5"
        >
          <DiscordIcon className="w-5 h-5" />
          Unite al Discord
        </a>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          <Stat value="5" label="Días por semana" />
          <Stat value="∞" label="Buena energía" />
          <Stat value="100%" label="Amor y calma" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col items-center">
      <span className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-b from-rose-200 to-sky-200">
        {value}
      </span>
      <span className="text-xs text-slate-400/60 mt-1 tracking-wide">{label}</span>
    </div>
  );
}
